module.exports = __webpack_public_path__ + "img/part-2-info.1bbb1faf.png";